import React, { useState } from 'react';
import { Col, Form, Row, Input, Select } from 'antd';
import { FAILED_REASONS, ORDER_PACKAGE_WAS, ORDER_STATUSES } from '../../../constants';
import './DeliveryStatusForm.scss';
import AddressInput from '../../Inputs/AddressInput';
import isEmpty from 'lodash/isEmpty';

const DeliveryStatusForm = ({ form, order, isHandledByVeloyd }) => {
  const [showNeigbourAddress, setShowNeigbourAddress] = useState(
    order.status === ORDER_STATUSES.COMPLETED &&
      (order.packageWas === ORDER_PACKAGE_WAS.DELIVERED_AT_NEIGHBOUR || isHandledByVeloyd),
  );

  const onPackageWasChange = (packageWas) => {
    // update state to enable address field if relevant
    setShowNeigbourAddress(packageWas === ORDER_PACKAGE_WAS.DELIVERED_AT_NEIGHBOUR);

    // clear the address field if packageWas is changed to something other than at neighbour
    if (packageWas !== ORDER_PACKAGE_WAS.DELIVERED_AT_NEIGHBOUR) {
      form.setFieldsValue({ neighbourAddress: null });
    }
  };

  return (
    <div className={`DeliveryStatusForm`}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Package was" name="packageWas">
            <Select
              options={Object.values(ORDER_PACKAGE_WAS).map((value) => ({
                value,
                label: value || '-',
              }))}
              size="large"
              placeholder="Package was"
              //disabled={!showNeigbourAddress}
              onChange={onPackageWasChange}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Neighbour Address"
            name="neighbourAddress"
            rules={[
              {
                validator: (_, value) => {
                  if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                    return Promise.resolve();
                  }

                  if (isEmpty(value?.address) && showNeigbourAddress) {
                    return Promise.reject(new Error('Required'));
                  }

                  if (isEmpty(value?.address) && !showNeigbourAddress) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('Invalid'));
                },
              },
            ]}
          >
            <AddressInput
              size="large"
              placeholder="Address"
              onSelect={(value) => form.setFieldsValue({ neighbourAddress: value })}
              disabled={!showNeigbourAddress}
              rules={[
                {
                  required: showNeigbourAddress,
                  message: "Please provide neighbour's address",
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label="Failed reason" name="failedReason">
            <Select
              options={Object.values(FAILED_REASONS).map((value) => ({
                value,
                label: value || '-',
              }))}
              size="large"
              disabled={isHandledByVeloyd || order.status !== ORDER_STATUSES.AWAITING_NEXT_ATTEMPT}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Rider note" name="riderNote">
            <Input size="large" placeholder="Notes from the rider" disabled={isHandledByVeloyd} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default DeliveryStatusForm;
